import { FunctionComponent } from 'preact';

import { List } from '../List/List';
import { useQualityLevels } from '../../hooks/useQualityLevels';

export const Quality: FunctionComponent = () => {
  const { qualitiesList, selectedQuality, selectQuality } = useQualityLevels();

  return (
    <div>
      <List
        value={selectedQuality}
        options={qualitiesList}
        onSelectedValueChange={selectQuality}
      />
    </div>
  );
};
